module.exports = __webpack_public_path__ + "static/img/logo.c58f8e81.svg";